import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Countries from './Countries';

const FlagText = () => {
  const getRandomCountry = () => Countries[Math.floor(Math.random() * Countries.length)];

  const [currentCountry, setCurrentCountry] = useState(getRandomCountry());

  // ✅ This useEffect will log the country every time it changes
  useEffect(() => {
    console.log("country is", currentCountry);
  }, [currentCountry]);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentCountry(getRandomCountry());
    }, 2500); // change flag every 2.5 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <div
      style={{
        display: 'inline-block',
        minWidth: '2ch',
        position: 'relative',
        height: '1em',
      }}
    >
      <AnimatePresence>
        <motion.span
          key={currentCountry.flag}
          initial={{ y: '100%', opacity: 0 }}
          animate={{ y: '0%', opacity: 1 }}
          exit={{ y: '-100%', opacity: 0 }}
          transition={{ duration: 0.4 }}
          style={{
            position: 'absolute',
            left: 0,
          }}
        >
          {"" + currentCountry.flag}
        </motion.span>
      </AnimatePresence>
    </div>
  );
};

export default FlagText;
